export async function espsQuery({ client }) {
  const { data } = await client.get(`esps/`);
  return data;
}
